$(document).ready(function () {
  "use strict";
 
  function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight)
    );
  }


  $(window).on("load scroll", function () {
    var scrollTop = $(window).scrollTop();
    var mainButton = document.querySelector(".add-to-cart-btn");
  
    function isInViewport(el) {
      const rect = el.getBoundingClientRect();
      return rect.top >= 0 && rect.bottom <= window.innerHeight;
    }
  
    if (scrollTop > 1200 && mainButton && !isInViewport(mainButton)) {
      $(".sticky-add-to-cart-section").addClass("fixed");
    } else {
      $(".sticky-add-to-cart-section").removeClass("fixed");
    }
  });
  


  $(".sticky-change-option-btn").click(function (event) {
    event.stopPropagation();
    $(".sticky-add-to-card-varient-box").addClass("active");
  });

  $(".sticky-add-to-card-varient-box-close").click(function (event) {
    event.stopPropagation();
    $(".sticky-add-to-card-varient-box").removeClass("active");
  });

  $(".close-sticky-add-to-cart").click(function (event) {
    event.stopPropagation();
    $(".sticky-add-to-card-varient-box").removeClass("active");
  });
  // sticky-add-to-cart-section js end--

  // **..accordion js start..**
  $(".accordion-toggle-btn").on("click", function () {
    $(this).next().slideToggle();
    $(this).parent().toggleClass("active");
    $(this)
      .parent()
      .siblings()
      .removeClass("active")
      .find(".product-single-accordion-item-content")
      .slideUp();
    $(this)
      .parent()
      .siblings()
      .removeClass("active")
      .find(".faq-accordion-item-content")
      .slideUp();
  });
  // **..accordion js end..**

  // product-single-slider js start---
  var swiper = new Swiper(".product-single-slider-thumb", {
    direction: "vertical",
    loop: true,
    spaceBetween: 20,
    slidesPerView: 5,
    freeMode: true,
    breakpoints: {
      // when window width is >= 320px
      1: {
        spaceBetween: 12,
        slidesPerView: 4,
        direction: "horizontal",
      },
      // when window width is >= 576px
      576: {
        spaceBetween: 16,
        slidesPerView: 5,
        direction: "horizontal",
      },
      // when window width is >= 768px
      768: {
        spaceBetween: 20,
        slidesPerView: 6,
        direction: "horizontal",
      },
      // when window width is >= 767px
      993: {
        direction: "vertical",
        spaceBetween: 20,
        slidesPerView: 5,
      },
    },
  });
  var swiper2 = new Swiper(".product-single-slider", {
    loop: true,
    spaceBetween: 10,
    thumbs: {
      swiper: swiper,
    },
  });
  // product-single-slider js end---

  // product slider js start--
  var swiper = new Swiper(".product-slider", {
    slidesPerView: 3,
    spaceBetween: 30,
    grabCursor: true,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      // when window width is >= 320px
      1: {
        spaceBetween: 10,
        slidesPerView: 2,
      },
      // when window width is >= 768px
      576: {
        spaceBetween: 15,
        slidesPerView: 2.2,
      },
      // when window width is >= 993px
      993: {
        spaceBetween: 20,
        slidesPerView: 3,
      },
      // when window width is >= 1140x
      1140: {
        spaceBetween: 25,
        slidesPerView: 3.6,
      },
      // when window width is >= 1290px
      1290: {
        spaceBetween: 30,
        slidesPerView: 3,
      },
    },
  });
});

// video player js end....

// btn js ---
// primary btn---
$(function () {
  $(".primary-btn")
    .on("mouseenter", function (e) {
      var parentOffset = $(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
      $(this).find("span").css({
        top: relY,
        left: relX,
      });
    })
    .on("mouseout", function (e) {
      var parentOffset = $(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
      $(this).find("span").css({
        top: relY,
        left: relX,
      });
    });
});

// secondary btn--
$(function () {
  $(".secondary-btn")
    .on("mouseenter", function (e) {
      var parentOffset = $(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
      $(this).find("span").css({
        top: relY,
        left: relX,
      });
    })
    .on("mouseout", function (e) {
      var parentOffset = $(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
      $(this).find("span").css({
        top: relY,
        left: relX,
      });
    });
});
// btn js ---

// product slider js end--

// progesss-bar js start--
const progress = document.querySelector(".progress");
progress.addEventListener("input", function () {
  const value = this.value;
  this.style.background = `linear-gradient(to right,rgb(237, 28, 36) 0%,rgb(237, 28, 36) ${value}%,rgb(216, 216, 216) ${value}%)`;
});
// progesss-bar js end--


$(document).ready(function () {
  // when enable quanity bundle

  let price = $(".quanity-input:checked").data("price");
  let compare = $(".quanity-input:checked").data("compare");
  let rate = $(".quanity-input:checked").data("rate");
  let plan = $("#select_delivery_time option:selected").text();
  $('.delivary-frequency').text(plan);
  
  if (compare > price) {
    price = price * 0.01;
    compare = compare * 0.01;
    var save = (compare - price * rate).toFixed();
    $(".fixed_discount").text("Save " + currency + save);
  } else {
    price = price * 0.01;
    var save = (price - price * rate).toFixed();
    $(".fixed_discount").text("Save " + currency + save);
  }

  $(".quanity-input").on("change", function () {
    var qty = $(this).val();
    let price = $(this).data("price");
    let compare = $(this).data("compare");
    let rate = $(this).data("rate");
    let plan = $(".plan_selector:checked").val();
    // let rate = $('.plan_input').data('rate');
    priceUpdate(price, compare, rate, plan, qty);
    $(".single-product-quantity-total-input").val(qty);
  });

  $(document).on("change", ".plan_selector", function () {
    $(this).parent().addClass("active").siblings().removeClass("active");
    var id = $(this).val();
    var input = $("#quanity_input_3");
    var qty = $(".single-product-quantity-total-input").val();
    let price = input.data("price");
    let compare = input.data("compare");
    let rate = input.data("rate");
    let plan = id;
    // let rate = $('.plan_input').data('rate');
    priceUpdate(price, compare, rate, plan, qty);

    var subs = $(".select-delivery-time option:selected").val();
    if (id == 1) {
      $("#selling_plan").val(subs);
      // $('.total-value, .value_price').show();
    } else {
      $("#selling_plan").val("");
      // $('.total-value, .value_price').hide();
    }
  });


  // quantity plus
  $(document).on("click", ".qty_plus", function () {
    var qty = parseInt($(this).prev().val());
    qty++;
    $(".single-product-quantity-total-input").val(qty);
    var input = $("#quanity_input_1");
    let price = input.data("price");
    let compare = input.data("compare");
    let rate = input.data("rate");
    let plan = $(".plan_selector:checked").val();
    priceUpdate(price, compare, rate, plan, qty);
  });
  // quantity minus
  $(document).on("click", ".qty_minus", function () {
    var qty = parseInt($(this).next().val());
    if (qty > 1) {
      qty--;
      $(".single-product-quantity-total-input").val(qty);
      var input = $("#quanity_input_1");
      let price = input.data("price");
      let compare = input.data("compare");
      let rate = input.data("rate");
      let plan = $(".plan_selector:checked").val();
      priceUpdate(price, compare, rate, plan, qty);
    }
  });
});



function priceUpdate(price, compare, rate, plan, qty) {
  
  let final_price = price * 0.01 * rate;
  final_price = (final_price * qty).toFixed(2);
  price = price * qty;
  price = (price * 0.01).toFixed(2);
  compare = compare * qty;
  compare = (compare * 0.01).toFixed(2);
  let discount = 0.85;

  if (qty >= 3) {
    $(".subs_price").text(currency + (final_price * discount).toFixed(2));
    $(".onetime_price").text(currency + (price * discount).toFixed(2));
    if (compare > price) {
      var save = compare - final_price * discount;
    } else {
      var save = price - final_price * discount;
    }
    $(".fixed-discount").text("Save " + currency + save.toFixed());

  } else {
    $(".subs_price").text(currency + final_price);
    $(".onetime_price").text(currency + price);

    if (compare > price) {
      var save = (compare - final_price).toFixed();
    } else {
      var save = (price - final_price).toFixed();
    }

    $(".fixed-discount").text("Save " + currency + save);
  }

  if (plan == 1) {
    
    $('.subscribe-text').addClass('show').removeClass('hide');
    $('.onetime-text').removeClass('show').addClass('hide');

    if (qty >= 3) {
      $(".reg_cost").text(currency + (final_price * discount).toFixed(2));
    } else {
      $(".reg_cost").text(currency + final_price);
    }
    
    $(".total-value").show();
    if (compare > 0) {
      $(".value_price")
        .show()
        .text(currency + compare);
    } else {
      $(".value_price")
        .show()
        .text(currency + price);
    }
  } else {
    $('.subscribe-text').addClass('hide').removeClass('show');
    $('.onetime-text').removeClass('hide').addClass('show');
    if (compare > price) {
      $(".total-value").show();
      $(".value_price")
        .show()
        .text(currency + compare);
    } else {
      $(".value_price").hide();
      $(".total-value").hide();
    }

    if (qty >= 3) {
      $(".reg_cost").text(currency + (price * discount).toFixed(2));
      $(".total-value").show();
      $(".value_price")
        .show()
        .text(currency + price);
    } else {
      $(".reg_cost").text(currency + price);
    }
  }

  if (qty == 2) {
    $(".quanity-input").prop("checked", false).removeAttr("checked");
  } else if (qty >= 3) {
    $(".quanity-input").prop("checked", false); // Uncheck all first
    $("#quanity_input_3").prop("checked", true).attr("checked", "checked");
  } else if (qty === 1) {
    $(".quanity-input").prop("checked", false); // Uncheck all first
    $("#quanity_input_1").prop("checked", true).attr("checked", "checked");
  }

  let progress = 0;

  if (qty == 1) {
    progress = 33;
    $(".discont-text").text("You’re " + (3 - qty) + " Items away from 15% Off");
  } else if (qty == 2) {
    progress = 66;
    $(".discont-text").text("You’re " + (3 - qty) + " Items away from 15% Off");
  } else {
    progress = 100;
    $(".discont-text").text("Congratulations! You got a 15% discount.");
  }

  $(".progress em").css("width", progress + "%");
}


$(document).on('change', 'input[data-shared-group="plan"]', function () {
  const selectedValue = $(this).val(); // 1 or 0
  const inputGroup = $(this).data('shared-group');

  // Sync all inputs of the same shared group and value
  $(`input[data-shared-group="${inputGroup}"]`).each(function () {
      if ($(this).val() == selectedValue) {
          $(this).prop('checked', true);
          $(this).parent().addClass('active').siblings().removeClass('active');
      } else {
          $(this).prop('checked', false);
      }
  });

  // Trigger change manually to fire your existing logic
  $('.select-delivery-time').trigger('change');
  $('.variant_selector').trigger('change');
});
